module.exports = __webpack_public_path__ + "assets/img/gd3.94ca16d2.jpg";